// Statement (明細書) cells print bare values: no currency sign, no unit.

export const formatAmount = (value?: number | null) => (value == null ? '' : new Intl.NumberFormat('ja-JP').format(value))

// The API sends durations as "[D ]HH:MM:SS"; the slip prints total hours as "H:MM".
export const formatDuration = (value?: string | null) => {
    const match = value?.match(/^(?:(\d+) )?(\d+):(\d{2}):(\d{2})/)
    if (!match) return ''
    const [, days, hours, minutes] = match
    return `${Number(days ?? 0) * 24 + Number(hours)}:${minutes}`
}
